import { useForkRef } from '@mui/material';
import { useRef, forwardRef, ElementType, cloneElement, ReactElement, Ref } from 'react';

export interface HoverTrackerProps {
  trackingAction: string;
  trackingProps?: object;
  children: ReactElement & { ref?: Ref<ElementType> };
  style?: object;
  [key: string]: string | number | object | boolean | VoidFunction | null | undefined;
}

function composeEventHandler(
  handler: (event: MouseEvent) => void,
  eventHandler: (event: MouseEvent) => void
): (event: MouseEvent) => void {
  return event => {
    if (eventHandler) {
      eventHandler(event);
    }

    handler(event);
  };
}

export const HoverTracker = forwardRef<ElementType, HoverTrackerProps>(
  ({ children, trackingAction, trackingProps, style = {}, ...props }: HoverTrackerProps, ref) => {
    const handleRef = useForkRef(children.ref, ref);

    const childrenProps = {
      ...props,
      ...children.props,
      style: {
        ...children.props.style,
        ...style
      },
      ref: handleRef
    };

    const timeoutRef = useRef<NodeJS.Timeout>();

    const minHoverDuration = 1000;

    const onMouseEnter = () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        // TODO: update this
        // eventTrack({
        //   action: trackingAction,
        //   properties: trackingProps
        // });
      }, minHoverDuration);
    };

    const onMouseLeave = () => {
      clearTimeout(timeoutRef.current);
    };

    if (trackingAction) {
      childrenProps.onMouseEnter = composeEventHandler(onMouseEnter, childrenProps.onMouseEnter);
      childrenProps.onMouseLeave = composeEventHandler(onMouseLeave, childrenProps.onMouseLeave);
    }

    return <>{cloneElement(children, childrenProps)}</>;
  }
);
